<template>
  <div class="select-city-container" v-show="show">
    <template v-if="isIPad">
      <div :class="{'pop-container-mask':true, 'bg-ipad':isIPad}" @click="_clickMask"></div>
      <div class="ipad-pop-container-content">
        <header class="title">
          <i class="icon-close" @click="_clickMask"></i>
          <h2>{{gettext('选择城市')}}</h2>
        </header>
        <main>
          <div v-for="(city, index) in cityList" class="city-list">
            <p :class="{'item':true, 'selected': currentSelected === city.cityName}" @click="handleSelected(city)">{{city.cityName}}</p>
          </div>
        </main>
        <footer>
          <span class="btn-confirm" @click="handleConfirm">{{gettext('确认')}}</span>
        </footer>
      </div>
    </template>
    <template v-else>
      <div class="pop-container-mask" @click="_clickMask"></div>
      <div class="pop-container-content">
        <i class="icon-close" @click="_clickMask"></i>
        <h2>{{gettext('选择城市')}}</h2>
        <p class="location">{{gettext('当前定位城市：')}}{{locationCity}}</p>
        <div v-for="(city, index) in cityList" class="city-list">
          <p :class="{'item':true, 'selected': currentSelected === city.cityName}" @click="handleSelected(city)">{{city.cityName}}</p>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    locationCity: {
      type: String,
      default: ''
    },
    cityList: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentSelected: ''
    }
  },
  watch: {
    cityList (nval) {
      const cityInfo = nval.find((item) => {
        return item.isSelected === true
      })
      this.currentSelected = cityInfo ? cityInfo.cityName : ''
    }
  },
  methods: {
    _clickMask () {
      this.$emit('clickMask')
    },
    handleSelected (city) {
      this.currentSelected = city.cityName
      this.currentCityObj = city
      if (!this.isIPad) {
        this.$emit('select', city)
      }
    },
    handleConfirm () {
      this.$emit('select', this.currentCityObj)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/variables"
$conversion = 0.5859375px
.select-city-container
  display flex
  justify-content center
  position absolute
  top 0
  left 0
  height 100%
  width 100%
  z-index 9
  overflow-y scroll
  .pop-container-mask
    position fixed
    top 0
    left 0
    height 100%
    width 100%
    background-color #fff
    &.bg-ipad
      background-color rgba(51,55,64,0.6)
  .pop-container-content
    z-index 2
    padding 113px 40px 0
    width 100%
    .icon-close
      margin 20px 0 40px 5px
      width 22px
      height 22px
      display block
      background url("~@/assets/images/common/close@2x.png") no-repeat
      background-size 100% 100%
    .title
      font-size 56px
      color #333
      line-height 56px
    .location
      padding 50px 0
      font-size 32px
      color #999
      line-height 28px
      border-bottom 1px solid #E5E4E4
    .city-list
      padding 19px 0 0
      .item
        position relative
        padding 30px 0
        &.selected
          &::after
            position absolute
            right 0
            top 50%
            margin-top -15px
            content ""
            display block
            width 40px
            height 30px
            icon-checked()
  .ipad-pop-container-content
    z-index 2
    margin auto
    width 540*$conversion
    min-height 354*$conversion
    background-color #fff
    .title
      position relative
      padding 0 72*$conversion
      height 90*$conversion
      line-height 90*$conversion
      font-size 30*$conversion
      color #333333
      border-bottom 1*$conversion solid #eee
      .icon-close
        position absolute
        margin-top -10*$conversion
        left 34*$conversion
        width 20*$conversion
        height 20*$conversion
        top 50%
        display block
        background url("~@/assets/images/common/close.png") no-repeat
        background-size 100% 100%
    .city-list
      .item
        position relative
        padding 24*$conversion 36*$conversion 28*$conversion
        font-size 22*$conversion
        color #333
        border-bottom 1*$conversion solid #eee
        &.selected
          background #F3F4F5
          &::after
            position absolute
            right 40*$conversion
            top 50%
            margin-top -14*$conversion
            content ""
            display block
            width 28*$conversion
            height 28*$conversion
            icon-checked-ipad()
    footer
      margin 25*$conversion 0
      padding-right 40*$conversion
      display flex
      justify-content flex-end
      .btn-confirm
        width 120*$conversion
        height 46*$conversion
        line-height 46*$conversion
        text-align center
        display block
        font-size 20*$conversion
        button-font-color()
        background-gradient()
        border-radius 2*$conversion
</style>

